import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TabCategory } from '../../documents';
import { UrlBuilder } from '../../core';

@Component({
    selector: 'admin-kit-inventory',
    template: require('./admin-kit-inventory.component.html'),
    styles: [require('./admin-kit-inventory.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminKitInventoryComponent {

    public tabs: TabCategory[];

    constructor(
        private urlBuilder: UrlBuilder,
    ) {
        const inventorySummaryUrl = this.urlBuilder
            .esa()
            .admin()
            .kitInventory()
            .inventorySummary()
            .url();
        const expirationUrl = this.urlBuilder
            .esa()
            .admin()
            .kitInventory()
            .onHandExpiration()
            .url();

        this.tabs = [{ name: 'Inventory Summary Report', url: inventorySummaryUrl }, { name: 'On Hand Inventory with Expiration Dates Report', url: expirationUrl }];
    }

}